export default "__VITE_ASSET__6d3233d4__"